import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-dark-950 text-center px-4">
      <h1 className="text-8xl md:text-[10rem] font-black text-white/5 select-none pointer-events-none">
        404
      </h1>
      <div className="relative -mt-16">
        <h2 className="text-xl md:text-2xl font-semibold text-gray-100 mt-6">Sayfa Bulunamadı</h2>
        <p className="mt-3 text-sm text-gray-500">Aradığınız sayfa mevcut değil veya taşınmış olabilir.</p>
        <button
          onClick={() => navigate("/")}
          className="mt-6 btn-gold inline-flex"
        >
          <i className="ri-arrow-left-line" />
          Dashboard&apos;a Dön
        </button>
      </div>
    </div>
  );
}